var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};


site.frontpage = {
	init: function() {
		$('#umm ul').bxSlider({
			slideMargin:0,
			pager:false,
			pause:12000,
			auto: true,
			minSlides:1
		});
		$('#promoCar ul').bxSlider({
			slideWidth:170,
			slideMargin:18,
			pager:false,
			pause:5000,
			auto: true,
			minSlides:1,
			maxSlides:5

		});


		var $tabs = $('#frontTabs');
		var $nav = $tabs.find('.tabNav');
		$('#frontTabs .box').each(function(i) {
			var $title = $('.boxTitle',this);
			$nav.append('<li><a href=\"#'+$(this).attr('id')+'\">'+$title.find('h3').text()+'</a></li>');
			$title.hide();
		});
		$tabs.find('.box_ord_0').addClass('active');
		$nav.find('li:first').addClass('active');

		$nav.find('li a').click(function(e) {
			var $this = $(this);
			var id = $this.attr('href');//.replace('#','');
			$tabs.find('.box.active').toggleClass('active');
			$nav.find('li.active').toggleClass('active');
			$this.parent().toggleClass('active');
			$tabs.find(id).toggleClass('active');
			e.preventDefault();
		});
		$nav.find('li:not(:first)').each(function(i){
			$('a',this).prepend('<span>'+(i+1)+'</span>');
		});
		$tabs.find('.button').click(function(e) {
			var href = $(this).attr('href');
			$tabs.find('.box.active').toggleClass('active');
			$nav.find('li.active').toggleClass('active');

			$tabs.find(href).toggleClass('active');
			$nav.find('a[href="'+href+'"]').parent().toggleClass('active');
			e.preventDefault();
		});
		$('#frontBottom .showMore').click(function(e) {
			$box = $("#frontBottom .menu");
			minimumHeight = 382;

			currentHeight = $box.innerHeight();
			autoHeight = $box.css('height', 'auto').innerHeight();
			$box.css('height', currentHeight).animate({
				height: (currentHeight == autoHeight ? minimumHeight : autoHeight)
			},500, function() {
				$('#frontBottom .more').toggle();
				$('#frontBottom .entriesFooter a').toggle();
			})
			e.preventDefault();
		});
		$cards = $('#main #cards');
		$('#banner li.i1').addClass('active');
		$cards.find('li.i1').addClass('active hover');
		$cards.find('li').hover(function() {
			var $this = $(this);
			$cards.find('li').removeClass('active hover');
			$this.toggleClass('hover');
			var $banner = $('#banner');
			var li = $banner.find('li:eq('+$this.index()+')');
			if(!li.hasClass('active')) {
				$banner.find('li.active').stop(true,true).removeClass('active').fadeTo('slow',0);
				li.stop(true,true).addClass('active').fadeTo('slow',1);
			}
		});
		$('#main .box_ord_3 .boxText h2').nextUntil('ul').andSelf().wrapAll('<div class="fWrap" />');
		$('#main .box_ord_3 .boxText').append('<br class="clear" />');
		nextCard();
		function nextCard() {
			$cards.find('li').each(function(i,el) {
				setTimeout(function(){$(el).trigger('mouseover');},8000+i*8000);
			});
		}
		setTimeout(function(){nextCard();},24000);
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	if ($body.is('.m3')) {
		var $banner = $('#subBanner');
		var li = $banner.find('li:eq('+$("#mainmenu2 .selectedLevel2").index()+')');
		li.css('opacity',1);
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	$('#main .boxText .table1 tr:even,#main .boxText .table2 tr:even').addClass('even');
	$('#main .boxText .table1 tr:first').addClass('first');
	$('#main .boxText .table1 .special').next().removeClass('even');
	$('#main .boxText .table2 tr').each(function() {
		$this = $(this);
		$this.find('td:first-child').addClass('first');
		$this.find('td').wrapInner('<div class="tdw" />');
	});


	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
